<!--
  ~ Copyright (c) 2019. Sonrai Analytics Ltd.
  ~ Developed by Chris Morgan & Gerard Loughran
  -->

<mat-drawer-container class="sidebar-container">
  <!-- <div class="sidebar-main"> -->
  <div
    class="sidebar-main"
    [ngClass]="expandSubmenu === true ? 'sidebar-main-expanded' : 'sidebar-main-closed'"
  >
    <div class="logo-header">
      <img
        id="sidebar-logo"
        class="logo-icon"
        [src]="appLogo"
        alt="Sonrai Discovery"
        [routerLink]="['/dashboard']"
      />
    </div>
    <div class="sidebar-content" *ngIf="user">
      <!-- Floating Action Menu Expand Buttons -->
      <button
        *ngIf="!expandSubmenu"
        (click)="openSubmenu()"
        mat-mini-fab
        class="submenu-toggle-button submenu-toggle-button-closed"
        color="primary"
        matTooltip="Click to Expand Menu"
        matTooltipPosition="right"
      >
        <mat-icon>code</mat-icon>
      </button>

      <button
        *ngIf="expandSubmenu"
        (click)="closeSubmenu()"
        mat-mini-fab
        class="submenu-toggle-button submenu-toggle-button-opened"
        color="primary"
        matTooltip="Click to Close Menu"
        matTooltipPosition="right"
      >
        <mat-icon>code</mat-icon>
      </button>

      <!-- New Sidebar Menu-->
      <mat-accordion>
        <!-- Home Menu -->
        <mat-nav-list class="sidemenu-link">
          <a
            mat-list-item
            routerLink="/dashboard"
            routerLinkActive="active-item"
            matTooltip="Home Dashboard"
            matTooltipPosition="right"
          >
            <mat-icon>home</mat-icon>
            <span class="title-text"> Home </span>
          </a>

          <a
            mat-list-item
            *ngIf="!isMedicalDevice && viewProjectsPermission && settings && settings.displayProjects"
            routerLink="/projects"
            id="project-icon"
            routerLinkActive="active-item"
            [routerLinkActiveOptions]="{ exact: true }"
            matTooltip="Projects List"
            matTooltipPosition="right"
          >
            <mat-icon>list_alt</mat-icon>
            <span class="title-text">Projects</span>
          </a>

          <a
            mat-list-item
            *ngIf="!!isMedicalDevice"
            [routerLink]="['/images']"
            routerLinkActive="active-item"
            [routerLinkActiveOptions]="{ exact: true }"
            matTooltip="Slides"
            matTooltipPosition="right"
            class="hitbox"
          >
            <mat-icon>photo_library</mat-icon>
            <span class="title-text"> Slides</span>
          </a>
        </mat-nav-list>

        <mat-expansion-panel
          *ngIf="
            activatedRoute.snapshot['_urlSegment'].segments.length > 1 &&
            activatedRoute.snapshot['_urlSegment'].segments[0].path === 'project'
          "
          [expanded]="true"
        >
          <mat-expansion-panel-header
            matTooltip="Project: {{ activatedRoute.snapshot['_urlSegment'].segments[1].path }}"
            matTooltipPosition="right"
          >
            <mat-icon>star</mat-icon>
            <span class="title-text">
              {{ activatedRoute.snapshot['_urlSegment'].segments[1].path }}</span
            >
          </mat-expansion-panel-header>

          <mat-nav-list class="sidebar-dropdown">
            <a
              mat-list-item
              routerLink="project/{{ activatedRoute.snapshot['_urlSegment'].segments[1].path }}"
              routerLinkActive="active-item"
              [routerLinkActiveOptions]="{ exact: true }"
              matTooltip="Project Overview"
              matTooltipPosition="right"
              class="hitbox"
            >
              <mat-icon class="icon-drop">developer_board</mat-icon>
              <span class="title-text"> Overview</span>
            </a>
            <a
              mat-list-item
              routerLink="project/{{
                activatedRoute.snapshot['_urlSegment'].segments[1].path
              }}/project-data"
              routerLinkActive="active-item"
              [routerLinkActiveOptions]="{ exact: true }"
              matTooltip="Project Data"
              matTooltipPosition="right"
              class="hitbox"
            >
              <mat-icon class="icon-drop">cloud_upload</mat-icon>
              <span class="title-text"> Data</span>
            </a>
            <a
              mat-list-item
              routerLink="project/{{
                activatedRoute.snapshot['_urlSegment'].segments[1].path
              }}/project-activity"
              routerLinkActive="active-item"
              [routerLinkActiveOptions]="{ exact: true }"
              matTooltip="Project Activity"
              matTooltipPosition="right"
              class="hitbox"
            >
              <mat-icon class="icon-drop">timeline</mat-icon>
              <span class="title-text"> Activity</span>
            </a>
            <a
              mat-list-item
              routerLink="project/{{
                activatedRoute.snapshot['_urlSegment'].segments[1].path
              }}/project-users"
              routerLinkActive="active-item"
              [routerLinkActiveOptions]="{ exact: true }"
              matTooltip="Project Users"
              matTooltipPosition="right"
              class="hitbox"
            >
              <mat-icon class="icon-drop">supervised_user_circle</mat-icon>
              <span class="title-text"> Users</span>
            </a>
            <a
              mat-list-item
              routerLink="project/{{
                activatedRoute.snapshot['_urlSegment'].segments[1].path
              }}/project-reports"
              routerLinkActive="active-item"
              [routerLinkActiveOptions]="{ exact: true }"
              matTooltip="Project Reports"
              matTooltipPosition="right"
              class="hitbox"
            >
              <mat-icon class="icon-drop">rule</mat-icon>
              <span class="title-text"> Reports</span>
            </a>
          </mat-nav-list>
        </mat-expansion-panel>

        <!-- Data Menu -->
        <mat-expansion-panel
          *ngIf="!isMedicalDevice && viewDatasetsPermission && settings && settings.displayDatasets"
          (opened)="openSubmenu()"
        >
          <mat-expansion-panel-header matTooltip="Data" matTooltipPosition="right">
            <mat-icon class="submenu-icon">source</mat-icon>
            <span class="title-text"> Data </span>
          </mat-expansion-panel-header>

          <mat-nav-list class="sidebar-dropdown">
            <a
              mat-list-item
              [routerLink]="['/datasets']"
              routerLinkActive="active-item"
              [routerLinkActiveOptions]="{ exact: true }"
              matTooltip="Datasets"
              matTooltipPosition="right"
              class="hitbox"
            >
              <mat-icon class="icon-drop">storage</mat-icon>
              <span class="title-text"> Datasets</span>
            </a>
            <a
              mat-list-item
              [routerLink]="['/data-repo']"
              routerLinkActive="active-item"
              [routerLinkActiveOptions]="{ exact: true }"
              matTooltip="Data Repository"
              matTooltipPosition="right"
              class="hitbox"
            >
              <mat-icon class="icon-drop">folder</mat-icon>
              <span class="title-text"> Repository</span>
            </a>
            <a
              mat-list-item
              [routerLink]="['/images']"
              routerLinkActive="active-item"
              [routerLinkActiveOptions]="{ exact: true }"
              matTooltip="Slides"
              matTooltipPosition="right"
              class="hitbox"
            >
              <mat-icon class="icon-drop">photo_library</mat-icon>
              <span class="title-text"> Slides</span>
            </a>
          </mat-nav-list>
        </mat-expansion-panel>

        <!-- Case Management which should be exclusive to SCPP / ImageDX-->
        <mat-expansion-panel *ngIf="!!isMedicalDevice && settings.displayCases" (opened)="openSubmenu()">
          <mat-expansion-panel-header matTooltip="Case Management" matTooltipPosition="right">
            <mat-icon class="submenu-icon">business_center</mat-icon>
            <span class="title-text"> Cases </span>
          </mat-expansion-panel-header>

          <mat-nav-list class="sidebar-dropdown">
            <a
              mat-list-item
              [routerLink]="['/my-cases']"
              routerLinkActive="active-item"
              [routerLinkActiveOptions]="{ exact: true }"
              matTooltip="My Cases"
              matTooltipPosition="right"
            >
              <mat-icon>view_list</mat-icon>
              <span class="title-text"> My Cases</span>
            </a>
            <a
              mat-list-item
              [routerLink]="['/cases']"
              routerLinkActive="active-item"
              [routerLinkActiveOptions]="{ exact: true }"
              matTooltip="All Cases"
              matTooltipPosition="right"
            >
              <mat-icon>view_module</mat-icon>
              <span class="title-text"> All Cases</span>
            </a>
            <a
              mat-list-item
              [routerLink]="['/unassigned-cases']"
              routerLinkActive="active-item"
              [routerLinkActiveOptions]="{ exact: true }"
              matTooltip="Unassigned Cases"
              matTooltipPosition="right"
            >
              <mat-icon>warning</mat-icon>
              <span class="title-text"> Unassigned Cases</span>
            </a>
          </mat-nav-list>
        </mat-expansion-panel>

        <!-- App Integrations -->
        <mat-nav-list class="sidemenu-link">
          <a
            mat-list-item
            *ngIf="!isMedicalDevice"
            routerLink="/integrations"
            routerLinkActive="active-item"
            matTooltip="Integrations"
            matTooltipPosition="right"
          >
            <mat-icon>apps</mat-icon>
            <span class="title-text"> Integrations </span>
          </a>
        </mat-nav-list>

        <!-- Admin Menu -->
        <mat-expansion-panel
          class="link-group"
          *ngIf="viewAdminPermission"
          (opened)="openSubmenu()"
        >
          <mat-expansion-panel-header matTooltip="Administration" matTooltipPosition="right">
            <mat-icon class="submenu-icon">miscellaneous_services</mat-icon>
            <span class="title-text">Admin</span>
          </mat-expansion-panel-header>
          <mat-nav-list class="sidebar-dropdown">
            <a
              mat-list-item
              [routerLink]="['/admin-dashboard']"
              routerLinkActive="active-item"
              [routerLinkActiveOptions]="{ exact: true }"
              matTooltip="Admin Dashboard"
              matTooltipPosition="right"
              class="hitbox"
            >
              <mat-icon class="icon-drop">settings</mat-icon>
              <span class="title-text"> Dashboard</span>
            </a>
            <a
              mat-list-item
              [routerLink]="['/admin/admin-user']"
              routerLinkActive="active-item"
              [routerLinkActiveOptions]="{ exact: true }"
              matTooltip="Manage Users"
              matTooltipPosition="right"
              class="hitbox"
            >
              <mat-icon class="icon-drop">groups</mat-icon>
              <span class="title-text"> Users </span>
            </a>

            <a
              *ngIf="!isMedicalDevice && settings && settings.displayProjects"
              mat-list-item
              [routerLink]="['/admin/admin-projects']"
              routerLinkActive="active-item"
              [routerLinkActiveOptions]="{ exact: true }"
              matTooltip="Manage Projects"
              matTooltipPosition="right"
              class="hitbox"
            >
              <mat-icon class="icon-drop">integration_instructions</mat-icon>
              <span class="title-text"> Projects</span>
            </a>

            <a
              *ngIf="!isMedicalDevice && settings && settings.displayProjects"
              mat-list-item
              [routerLink]="['/admin/admin-user-projects']"
              routerLinkActive="active-item"
              [routerLinkActiveOptions]="{ exact: true }"
              matTooltip="Project User Matrix"
              matTooltipPosition="right"
              class="hitbox"
            >
              <mat-icon class="icon-drop">view_list</mat-icon>
              <span class="title-text"> User-Projects</span>
            </a>

            <a
              mat-list-item
              [routerLink]="['/admin/admin-activity']"
              routerLinkActive="active-item"
              [routerLinkActiveOptions]="{ exact: true }"
              matTooltip="Admin Activity"
              matTooltipPosition="right"
              class="hitbox"
            >
              <mat-icon class="icon-drop">timeline</mat-icon>
              <span class="title-text"> Activity</span>
            </a>
            <a
              mat-list-item
              *ngIf="!isMedicalDevice"
              [routerLink]="['/admin/admin-integrations']"
              routerLinkActive="active-item"
              [routerLinkActiveOptions]="{ exact: true }"
              matTooltip="Manage Integrations"
              matTooltipPosition="right"
              class="hitbox"
            >
              <mat-icon class="icon-drop">cloud_upload</mat-icon>
              <span class="title-text"> Integrations</span>
            </a>

            <a
              mat-list-item
              [routerLink]="['/admin/admin-settings']"
              routerLinkActive="active-item"
              [routerLinkActiveOptions]="{ exact: true }"
              matTooltip="Organisation Settings"
              matTooltipPosition="right"
              class="hitbox"
            >
              <mat-icon class="icon-drop">settings</mat-icon>
              <span class="title-text"> Settings</span>
            </a>
            <a
              *ngIf="sonraiSuperUser"
              mat-list-item
              [routerLink]="['/admin/super-admin-dashboard']"
              routerLinkActive="active-item"
              [routerLinkActiveOptions]="{ exact: true }"
              matTooltip="Super Admin"
              matTooltipPosition="right"
              class="hitbox"
            >
              <mat-icon class="icon-drop">supervisor_account</mat-icon>
              <span class="title-text"> Super Admin</span>
            </a>
          </mat-nav-list>
        </mat-expansion-panel>

        <mat-nav-list class="sidemenu-link">
          <a
            *ngIf="!isMedicalDevice && settings && settings.displayImaging"
            mat-list-item
            [href]="imagingURL"
            target="_blank"
            matTooltip="InDRA Imaging"
            matTooltipPosition="right"
          >
            <mat-icon>image_search</mat-icon>
            <span class="title-text"> Imaging</span>
          </a>
        </mat-nav-list>
      </mat-accordion>
    </div>
  </div>
</mat-drawer-container>
